/* tslint:disable */
/* eslint-disable */
/**
 * pkg/api/event.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * +union
 * @export
 * @interface V1AppArmorProfile
 */
export interface V1AppArmorProfile {
    /**
     * localhostProfile indicates a profile loaded on the node that should be used.
     * The profile must be preconfigured on the node to work.
     * Must match the loaded name of the profile.
     * Must be set if and only if type is "Localhost".
     * +optional
     * @type {string}
     * @memberof V1AppArmorProfile
     */
    localhostProfile?: string;
    /**
     * +enum
     * @type {string}
     * @memberof V1AppArmorProfile
     */
    type?: string;
}

export function V1AppArmorProfileFromJSON(json: any): V1AppArmorProfile {
    return V1AppArmorProfileFromJSONTyped(json, false);
}

export function V1AppArmorProfileFromJSONTyped(json: any, ignoreDiscriminator: boolean): V1AppArmorProfile {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'localhostProfile': !exists(json, 'localhostProfile') ? undefined : json['localhostProfile'],
        'type': !exists(json, 'type') ? undefined : json['type'],
    };
}

export function V1AppArmorProfileToJSON(value?: V1AppArmorProfile | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'localhostProfile': value.localhostProfile,
        'type': value.type,
    };
}

